<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
    import Popover from '../../_common/popover.svelte'
    import { onMount } from 'svelte'
    import Categories from './categories.svelte'
    import { Category } from '../../../modules/financialApi/categories/category'
    import type { EntryTypeEnum } from '../../../modules/financialApi/entries/entry.enum'

    export let category: Category = null
    export let disabled: boolean = false
    export let small = false
    export let label = ''
    export let creditDebit: EntryTypeEnum = null

    let categories: Category[] = []
    let query = ''

    let delay = null
    async function search(query) {
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            categories = await window.api.financials.categories.getAll({ query, pageSize: 100, cd: creditDebit })
            if (categories.length === 0) dropHelper = 'Não encontrado.'
        }, 500)
    }
    async function getFirst100() {
        categories = await window.api.financials.categories.getAll({ pageSize: 100, cd: creditDebit })
    }

    function select(index) {
        category = categories[index]
        query = ''
        categories = []
    }

    async function loadService(categoryId) {
        if (categoryId) {
            category = await window.api.financials.categories.getOne(categoryId)
            _showDrop = false
        }
    }

    function friendlyName(p) {
        return p?.label || ''
    }

    function clear() {
        category = null
        _showDrop = false
    }

    let showForm = false
    function newService() {
        category = new Category()
        showForm = true
    }

    function editService() {
        showForm = true
    }

    async function hideForm(event) {
        showForm = false
        await getFirst100()
        if (event.detail?.serviceCategoryId) {
            category = event.detail
        }
    }

    let _showDrop = false
    let dropHelper = 'Digite ao menos 3 caracteres para pesquisar...'
    function showDrop(event) {
        _showDrop = true
    }

    function hideDrop(event) {
        setTimeout(() => {
            _showDrop = false
        }, 300)
    }

    onMount(async () => {
        await getFirst100()
    })

    $: {
        if (category?.categoryId && !category?.createdAt) loadService(category.categoryId)
        search(query)
    }
</script>

{#if showForm}
    <Popover on:close={hideForm} title="Categorias Financeiras" height="420px" width="970px">
        <Categories categoryId={category.categoryId} {creditDebit} form={true} on:close={hideForm} />
    </Popover>
{/if}
<div class="query">
    <div class="input-group custom-control" class:input-group-sm={small === true}>
        {#if label}
            <div class="input-group-text">{label}</div>
        {/if}
        {#if category && category.categoryId}
            <input
                class="form-control"
                class:form-control-sm={small === true}
                disabled
                value={friendlyName(category)}
                type="text"
            />
            <!-- <button on:click={editService} class="btn btn-secondary"><Fa icon={faEdit} /></button> -->
            {#if !disabled}
                <button class="btn btn-secondary" class:form-control-sm={small === true} on:click={clear}
                    ><Fa icon={faTimes} /></button
                >
            {/if}
        {:else}
            <input
                class="form-control btn-end select-icon"
                class:form-control-sm={small === true}
                type="text"
                bind:value={query}
                on:focus={showDrop}
                on:blur={hideDrop}
            />
            <button on:click={newService} class="btn btn-secondary"><Fa icon={faPlus} /></button>
        {/if}
    </div>

    {#if _showDrop}
        <div class="list scroll-dark">
            {#if categories.length === 0}
                <div class="list-helper p-2 text-muted">{dropHelper}</div>
            {:else}
                {#each categories as p, index}
                    <button
                        on:click={() => {
                            select(index)
                        }}>{friendlyName(p)}</button
                    >
                {/each}
            {/if}
        </div>
    {/if}
</div>

<style>
    .list-helper {
        color: #333;
        background-color: #eee;
    }
    .query {
        position: relative;
        flex-grow: 1;
        width: 100%;
    }
    .list {
        display: flex;
        flex-direction: column;
        box-shadow: 4px 3px 6px #111;
        position: absolute;
        flex-grow: 1;
        z-index: 5;
        width: 100%;
        overflow-y: auto;
        max-height: 200px;
    }
    .list button {
        flex-grow: 1;
        padding: 8px;
        text-align: left;
    }
    .list button:hover {
        background-color: #ddd;
    }
</style>
